import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { makeSxStyles } from "ui";

// Per Figma (node 13944-785698 / 13944-784092). Shared by both steps of the
// flow.
const CreateTempRouteWarningBanner: FC = () => {
  const styles = useStyles();

  return (
    <Box sx={styles.banner}>
      <Typography sx={styles.text}>
        Skipped orders will automatically return to their original routes at end
        of day, and this route will be removed.
      </Typography>
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  banner: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "14px 16px",
    borderRadius: "8px",
    background: "#004B6F",
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.15), 0px 1px 1.5px rgba(0, 0, 0, 0.3)",
  },
  text: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.1px",
    color: "#C9E6FF",
  },
}));

export default CreateTempRouteWarningBanner;
